import { render, staticRenderFns } from "./EditCoupon.vue?vue&type=template&id=2d5752fb&scoped=true"
import script from "./EditCoupon.vue?vue&type=script&lang=js"
export * from "./EditCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5752fb",
  null
  
)

export default component.exports